import { connect } from "react-redux";
import { openCountrySelector } from "@template/state/modules/countrySelector";
import RsftWelcomeMessage from "./RsftWelcomeMessage";

const mapStateToProps = state => ({
  country: state.welcomeMessage.country
});

const mapDispatchToProps = {
  openCountrySelector
};

export default connect(mapStateToProps, mapDispatchToProps)(RsftWelcomeMessage);
